export const SearchLogo = ({ className = "", color = "#333", ...props }) => (
  <svg className ={className}  xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none" viewBox="0 0 21 21" {...props}>
    <path
      stroke={color}
      stroke-linecap="round"
      stroke-width="2"
      d="m18.375 18.375-3.925-3.932m2.175-5.255a7.438 7.438 0 1 1-14.875 0 7.438 7.438 0 0 1 14.875 0Z"
    />
  </svg>
);
